// Global loading state for full-page overlay
import { ref } from 'vue';

// Global loading state for full-page overlay (generic)
export const isLoading = ref(false);

// Checkout-specific overlay visibility
export const isCheckoutOverlay = ref(false);
